import React from 'react';
import { Award, Lock, ExternalLink } from 'lucide-react';

const CertificateCard = ({ certificate, onLockedClick }) => {
  const { title, subtitle, locked, previewUrl } = certificate;

  return (
    <div
      className={`bg-gradient-to-br from-white/5 to-transparent border rounded-xl p-6 transition-all relative overflow-hidden ${
        locked
          ? 'border-white/10 cursor-not-allowed'
          : 'border-yellow-500/30 hover:border-yellow-500/50 cursor-pointer shadow-lg shadow-yellow-500/10'
      }`}
      onClick={() => locked && onLockedClick()}
    >
      {/* Overlay para locked */}
      {locked && (
        <div className="absolute inset-0 bg-black/40 rounded-lg z-10" />
      )}

      <div className="relative z-20">
        {/* Header */}
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-yellow-500/10 rounded-lg">
              <Award className="text-yellow-400" size={28} />
            </div>
            <div>
              <h3 className="text-xl font-bold text-yellow-400">{title}</h3>
              <p className="text-sm text-gray-400">{subtitle}</p>
            </div>
          </div>
          {locked && <Lock className="text-gray-500 flex-shrink-0" size={24} />}
        </div>

        {/* Nombre del programa */}
        <div className="mb-4 p-4 bg-gradient-to-r from-teal-500/10 to-transparent border border-teal-500/20 rounded-lg">
          <p className="text-sm text-gray-400 mb-1">Programa</p>
          <p className="font-bold text-lg">Urpe Liberty MBA</p>
          <p className="text-xs text-gray-500 mt-1">Dominio completo en negocios digitales y liderazgo</p>
        </div>

        {/* Imagen del certificado - Diseño similar al landing */}
        <div className="mb-4 rounded-lg overflow-hidden border-2 border-yellow-500/30 shadow-xl bg-white">
          <div className="p-8">
            {/* Certificate Header */}
            <div className="text-center mb-6 border-b border-gray-200 pb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_knowledge-hub-196/artifacts/464mphrk_Recurso%2026LOGO%20def.png"
                alt="Urpe School Logo"
                className="h-10 mx-auto mb-3"
                loading="lazy"
                decoding="async"
              />
              <h3 className="text-xl font-bold text-gray-900">Certificado de Cumplimiento</h3>
            </div>

            {/* Certificate Body */}
            <div className="text-center space-y-3">
              <p className="text-xs text-gray-600">Este certificado se otorga a</p>
              <h4 className="text-2xl font-bold text-teal-600">Tu Nombre</h4>
              <p className="text-xs text-gray-600">Por completar exitosamente</p>
              <p className="text-base font-semibold text-gray-900">Urpe Liberty MBA</p>
              <div className="pt-4 flex justify-center">
                <Award className="text-teal-500" size={28} />
              </div>
            </div>

            {/* Certificate Footer */}
            <div className="mt-6 pt-4 border-t border-gray-200 flex justify-between items-center">
              <div className="text-xs text-gray-500">
                <p>ID: URPE-2025-XXXX</p>
                <p>Fecha: 2025</p>
              </div>
              <div className="flex items-center space-x-1">
                <ExternalLink size={14} className="text-blue-600" />
                <span className="text-xs text-gray-500">Verificable</span>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        {locked ? (
          <div className="space-y-2">
            <button
              onClick={onLockedClick}
              className="w-full py-3 px-4 bg-teal-500/20 text-teal-400 rounded-lg font-medium text-sm hover:bg-teal-500/30 transition-all border border-teal-500/30"
            >
              🔒 Activa tu acceso para desbloquear
            </button>
            <p className="text-xs text-center text-gray-500">
              Completa el programa para obtener tu certificado
            </p>
          </div>
        ) : (
          <div className="space-y-2">
            <button className="w-full py-3 px-4 bg-gradient-to-r from-yellow-500 to-yellow-600 text-black rounded-lg font-bold hover:from-yellow-400 hover:to-yellow-500 transition-all flex items-center justify-center space-x-2 shadow-lg">
              <span>Descargar Certificado</span>
              <ExternalLink size={18} />
            </button>
            <p className="text-xs text-center text-gray-400">
              Certificado verificable • Comparte en LinkedIn
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CertificateCard;
